import { useState } from 'react';
import { Link } from 'react-router';
import { APP_NAME } from '@clanfire/shared';
import { Button } from './Button';

const KEY = 'clanfire:cookie-notice';

/**
 * A one-time note about cookies. Everything we store is strictly necessary, so
 * there's nothing to consent to: this just says so and links to the details.
 */
export function CookieNotice() {
  const [show, setShow] = useState(() => {
    try {
      return localStorage.getItem(KEY) !== 'seen';
    } catch {
      return false;
    }
  });
  if (!show) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(KEY, 'seen');
    } catch {
      /* storage unavailable: hide it for this visit */
    }
    setShow(false);
  };

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed inset-x-3 bottom-3 z-40 mx-auto flex max-w-lg animate-slide-up items-center gap-3 rounded-3xl border border-line bg-elevated py-2.5 pr-2.5 pl-5 text-sm text-fg-soft shadow-pop sm:bottom-5"
    >
      <p className="min-w-0 flex-1 leading-snug">
        {APP_NAME} only uses essential cookies, to keep you signed in and remember your settings.{' '}
        <Link to="/cookies" className="font-semibold whitespace-nowrap text-link hover:underline">
          Cookie Policy
        </Link>
      </p>
      <Button size="sm" onClick={dismiss}>
        Got it
      </Button>
    </div>
  );
}
